import { Deal, DealMovementItem, DealMovementType, DealTypes } from '../deals/dealModels'
import { MovementListItem, SapFlowStepStatus } from '../stock/stockModels'
import { t } from '../../infrastructure/i18nextHelper'

export type SapFlowStepName = 'STO' | 'PO' | 'GR' | 'SO' | 'DN' | 'GI' | 'GT' | 'MD' | 'RE'

export type SapType = MovementSapType | DealSapType
export type MovementSapType = 'sale' | 'sto' | 'stoDn' | 'stoGoodsIssue' | 'migo' | 'directTransfer' | 'rebranding309' |
    'purchase501' | 'gains' | 'losses' | 'poMigo' | 'poRelease' | 'soDn' | 'soGoodsIssue' | 'blo' | 'blMigo'
export type DealSapType = 'pcCreate' | 'scCreate' | 'updatePricingConditions' | 'updateDealSapQuantity' | 'purchase501'

export type TransferFlowType = 'sto' | 'direct301'

export type SapFlowStep = {
    shortName: SapFlowStepName | null
    sapType: MovementSapType
    sapFlowType: TransferFlowType | null
}

export let PurchaseOrder: SapFlowStep = { shortName: 'PO', sapType: 'purchase501', sapFlowType: null }
export let GoodReceipt: SapFlowStep = { shortName: 'GR', sapType: 'poMigo', sapFlowType: null }
export let PurchaseRelease: SapFlowStep = { shortName: 'RE', sapType: 'poRelease', sapFlowType: null }
export let SalesOrder: SapFlowStep = { shortName: 'SO', sapType: 'sale', sapFlowType: null }
export let SaleDeliveryNote: SapFlowStep = { shortName: 'DN', sapType: 'soDn', sapFlowType: null }
export let SaleGoodsIssue: SapFlowStep = { shortName: 'GI', sapType: 'soGoodsIssue', sapFlowType: null }
export let StockTransferOrder: SapFlowStep = { shortName: 'STO', sapType: 'sto', sapFlowType: 'sto' }
export let TransferDeliveryNote: SapFlowStep = { shortName: 'DN', sapType: 'stoDn', sapFlowType: 'sto' }
export let TransferGoodsIssue: SapFlowStep = { shortName: 'GI', sapType: 'stoGoodsIssue', sapFlowType: 'sto' }
export let GoodsTransfer: SapFlowStep = { shortName: 'GT', sapType: 'migo', sapFlowType: 'sto' }
export let DirectTransfer: SapFlowStep = { shortName: null, sapType: 'directTransfer', sapFlowType: 'direct301' }
export let Rebranding: SapFlowStep = { shortName: null, sapType: 'rebranding309', sapFlowType: null }
export let Gains: SapFlowStep = { shortName: 'MD', sapType: 'gains', sapFlowType: null }
export let Losses: SapFlowStep = { shortName: 'MD', sapType: 'losses', sapFlowType: null }
export let BorrowLoanOrder: SapFlowStep = { shortName: 'STO', sapType: 'blo', sapFlowType: null }
export let BorrowLoanGoodsTransfer: SapFlowStep = { shortName: 'GT', sapType: 'blMigo', sapFlowType: null }

export const goodsMovementAction: MovementSapType[] = [
    GoodsTransfer.sapType, DirectTransfer.sapType, Rebranding.sapType, Gains.sapType, Losses.sapType, GoodReceipt.sapType, BorrowLoanGoodsTransfer.sapType
]
export const poCreateAction: MovementSapType[] = [StockTransferOrder.sapType, PurchaseOrder.sapType, BorrowLoanOrder.sapType]
export const soCreateAction: MovementSapType = SalesOrder.sapType
export const poReleaseAction: MovementSapType = PurchaseRelease.sapType
export const deliveryAction: MovementSapType[] = [TransferDeliveryNote.sapType, SaleDeliveryNote.sapType]
export const goodsIssueAction: MovementSapType[] = [TransferGoodsIssue.sapType, SaleGoodsIssue.sapType]

export let isMultiSapFlow = (x: DealMovementItem | MovementListItem) =>
    x.secondSapFlowListItem != null && x.secondSapFlowListItem.steps.length > 0

export let steps = (x: MovementListItem | DealMovementItem, showAll: boolean)
    : { mainSapFlow: SapFlowStepStatus[], secondSapFlow?: SapFlowStepStatus[] } => {
    if (showAll)
        return {
            mainSapFlow: x.mainSapFlowListItem.steps,
            secondSapFlow: x.secondSapFlowListItem?.steps
        }
    else if (isMultiSapFlow(x))
        return {
            mainSapFlow: [x.mainSapFlowListItem.steps[0], x.secondSapFlowListItem!.steps[0]]
        }
    else
        return {
            mainSapFlow: x.mainSapFlowListItem.steps
        }
}

export let isTransferSapType = (sapType: MovementSapType) =>
    sapType == StockTransferOrder.sapType || sapType == TransferDeliveryNote.sapType
    || sapType == TransferGoodsIssue.sapType || sapType == DirectTransfer.sapType
    || sapType == GoodsTransfer.sapType

export let hasMaterialDocumentFilled = (steps: SapFlowStepStatus[]) =>
    steps.first(x => x.name === GoodReceipt.shortName || x.name === GoodsTransfer.shortName || x.name === Gains.shortName)?.isCompleted

export let dealSapTooltip = (type: DealSapType, dealMovementType: DealMovementType | undefined = undefined): string => {
    return {
        pcCreate: t('deals.label.sap.createPurchaseContractTooltip'),
        scCreate: t('deals.label.sap.createSalesContractTooltip'),
        updatePricingConditions: t('deals.label.sap.updatePricingConditionsTooltip'),
        updateDealSapQuantity: dealMovementType === DealMovementType.PURCHASE
            ? t('deals.label.sap.updateDealSapQuantityPurchaseTooltip')
            : t('deals.label.sap.updateDealSapQuantitySaleTooltip'),
        purchase501: t('deals.label.sap.purchase501Tooltip'),
    }[type]
}